module.exports = __webpack_public_path__ + "img/12_Q_spades.099d99c2.png";